<template>
    <Authenticated>
        <template #header>
            <PageTitle translationKey="dashboard.title"/>
        </template>

        <div class="flex flex-col lg:flex-row">
            <TableSmall :opportunities="opportunities"/>
            <UserDetails :user="user"/>
        </div>
    </Authenticated>
</template>

<script>
import UserDetails from "@/Components/User/Details";
import PageTitle from "@/Components/PageTitle";
import Authenticated from '@/Layouts/Authenticated';
import TableSmall from '@/Components/Opportunities/Table/TableSmall';

export default {
    props: ['user', 'opportunities'],
    components: {
        Authenticated,
        TableSmall,
        UserDetails,
        PageTitle,
    }
}

</script>
